"use client";
import AppLayout from "@/components/app/applayout";
import Hero from "@/components/privacy/hero";
import Main from "@/components/privacy/main";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";

export default function Service() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Hero />
      <Box className={classes.container}>
        <Main />
      </Box>
    </AppLayout>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    // flexDirection: "column",
    gap: theme.spacing(4),
    
  },
}));
